import { useEffect, useState } from 'react'
import cx from 'classnames'

import Styles from './SmartLink.module.scss'
import { Workspace } from 'types'
import { GithubIntegrationService } from 'api/services/GithubIntegrationService'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { FormatMenu } from './FomatMenu'
import { Spin } from 'common/Spin/Spin'
import { renderFallbackThumbnail } from './utils'

interface Props {
  attrs: { [key: string]: string | number }
  selected: boolean
  workspace?: Workspace
  readOnly?: boolean
}

export const SmartLink = ({ attrs, selected, workspace, readOnly }: Props) => {
  const [fetchedMetadata, setFetchedMetadata] = useState<{
    private?: boolean
    provider?: string
    status?: string
    title?: string
  }>({})
  const [loading, setLoading] = useState(false)

  const renderFormatMenu = () => {
    return <FormatMenu attrs={attrs} />
  }

  useEffect(() => {
    if (!workspace || !workspace.github_integration_enabled) return

    const fetchGithubMetadata = async () => {
      const { organization, endpoint, resourceId } = GithubIntegrationService.parseResourceUrl(attrs.url as string)

      const response = await WorkspaceClient.fetchGithubResourceMetadata(
        workspace.id,
        organization,
        endpoint,
        resourceId,
      )

      if (response?.type === SUCCESS_RESPONSE_TYPE) {
        setFetchedMetadata(response.data)
      }
    }

    switch (attrs.provider) {
      case 'github.com':
        setLoading(true)
        fetchGithubMetadata()
        setLoading(false)
        break

      default:
        break
    }
  }, [workspace, attrs])

  return (
    <>
      <div className={cx(Styles.urlContainer, { [Styles.selected]: selected })}>
        {selected && !readOnly && <>{renderFormatMenu()}</>}

        {loading && <Spin />}
        {!loading && (
          <>
            {!selected && !readOnly && <div className={cx(Styles.containerOverlay)}></div>}
            <a href={attrs.url as string} target="_blank" rel="noreferrer noopener">
              {renderFallbackThumbnail(attrs.provider as string)}
              {fetchedMetadata?.title || attrs.url}

              {fetchedMetadata?.status && <span className={Styles.statusBadge}>{fetchedMetadata.status}</span>}
            </a>

            <div className={Styles.integrationButton} />
          </>
        )}
      </div>
    </>
  )
}
